// extracted by mini-css-extract-plugin
export default {"customerReviews":"CustomerReviews-module_customerReviews-H+f+2","label":"CustomerReviews-module_label-SHTwU","seeAllReviewsLink":"CustomerReviews-module_seeAllReviewsLink-FP0xX"};